import type { HTMLAttributes } from 'react';
import './SeverityBanner.css';

interface SeverityBannerProps extends HTMLAttributes<HTMLDivElement> {
  pct: number;       // coverage % (0–100)
  label: string;
}

// red <5, amber <10, steel <20, accent ≥20
function severityKey(pct: number): 'bad' | 'warn' | 'info' | 'ok' {
  if (pct < 5) return 'bad';
  if (pct < 10) return 'warn';
  if (pct < 20) return 'info';
  return 'ok';
}

export function SeverityBanner({ pct, label, className = '', ...rest }: SeverityBannerProps) {
  const key = severityKey(pct);
  return (
    <div
      data-severity={key}
      className={`severity-banner ${className}`.trim()}
      {...rest}
    >
      <span className="severity-banner__bar" style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} />
      <span className="severity-banner__label">{label}</span>
      <span className="severity-banner__pct">{pct.toFixed(0)}%</span>
    </div>
  );
}
